import { render, staticRenderFns } from "./GroupedBoxList.vue?vue&type=template&id=0afd7dfa"
import script from "./GroupedBoxList.vue?vue&type=script&lang=js"
export * from "./GroupedBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports